module.exports = __webpack_public_path__ + "img/eprice-button-secondary-hovered.14bef666.png";